var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.25 14.625C47.5556 14.625 41.0475 5.99626 40.9987 5.92313C40.7741 5.60131 40.4751 5.33849 40.1271 5.15701C39.7791 4.97553 39.3925 4.88077 39 4.88077C38.6075 4.88077 38.2209 4.97553 37.8729 5.15701C37.5249 5.33849 37.2259 5.60131 37.0013 5.92313C37.0013 5.92313 30.4444 14.625 9.75 14.625C9.10353 14.625 8.48355 14.8818 8.02643 15.3389C7.56931 15.7961 7.3125 16.416 7.3125 17.0625V38.415C7.3125 60.9619 24.6431 67.665 34.9781 71.7113L38.0737 72.93C38.3655 73.059 38.681 73.1256 39 73.1256C39.319 73.1256 39.6345 73.059 39.9262 72.93L43.0219 71.7113C53.3569 67.6894 70.6875 60.9375 70.6875 38.415V17.0625C70.6875 16.416 70.4307 15.7961 69.9736 15.3389C69.5165 14.8818 68.8965 14.625 68.25 14.625Z",
    fill: "#D8E1EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26.8125C37.2852 26.8258 35.6295 27.4414 34.3225 28.5517C33.0155 29.662 32.1403 31.1963 31.8499 32.8865C31.5595 34.5766 31.8723 36.3151 32.7338 37.798C33.5952 39.2809 34.9505 40.4138 36.5625 40.9987V48.75C36.5625 49.3965 36.8194 50.0165 37.2765 50.4736C37.7336 50.9307 38.3536 51.1875 39 51.1875C39.6465 51.1875 40.2665 50.9307 40.7236 50.4736C41.1807 50.0165 41.4375 49.3965 41.4375 48.75V40.9987C43.0496 40.4138 44.4049 39.2809 45.2663 37.798C46.1277 36.3151 46.4406 34.5766 46.1502 32.8865C45.8598 31.1963 44.9846 29.662 43.6776 28.5517C42.3706 27.4414 40.7149 26.8258 39 26.8125V26.8125Z",
    fill: "#0593FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizLock);
export default __webpack_public_path__ + "static/media/quiz-lock.463f4373e9cdd92ee5fa082af20d4645.svg";
export { ForwardRef as ReactComponent };